import { u as p } from "../styled-components.browser.esm-3eb04950.js";
const t = p.span`
    display: flex;
    padding: 10px;
    min-width: ${({ $minWidth: i }) => i}px;
`;
export {
  t as BironListLine
};
//# sourceMappingURL=BironListLine.js.map
